jQuery( document ).ready( function ( $ ) {

	let allElemInSolution = document.querySelectorAll('.data-flow-list__item');

	if(body.classList.contains('without-animation')) {
		for (let elem of allElemInSolution) {
			elem.classList.add('element-show');
		}
	}

	function onEntry(entry) {
		entry.forEach(change => {
			if (change.isIntersecting) {
				change.target.classList.add('element-show');
			}
		});
	}

	let options = {
		root: null,
		rootMargin: '0px',
		threshold: 1
	};

	let observer = new IntersectionObserver(onEntry, options);

	for (let elm of allElemInSolution) {
		observer.observe(elm);
	}

	$(document).on('accessibilityPreEvent', function (e) {
		if ( e.originalEvent.detail['without-animation'] ) {
			for (let elem of allElemInSolution) {
				elem.classList.add('element-show');
			}
		}
	});
} );